import { Landmark, MousePointerClick, Package } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const steps = [
  { icon: MousePointerClick, t: "Pick your prints", d: "Add ready-made items to your cart, or send us your custom idea.", bg: "var(--cyan)" },
  { icon: Landmark, t: "Pay by bank transfer", d: "Place your order and you'll get our bank details plus your order reference.", bg: "var(--yellow)" },
  { icon: Package, t: "We print & send", d: "Once payment lands, your order is printed, packed and on its way.", bg: "var(--lime)" },
];

export const HowItWorks = () => (
  <section id="how" data-testid="how-it-works-bento" className="px-4 sm:px-8 py-20 sm:py-32">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <Eyebrow color="var(--lime)">How it works</Eyebrow>
        <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-5 mb-12 leading-[0.95]">
          Easy as <span className="font-serif-i font-normal">one, two, print.</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {steps.map((s, i) => (
          <Reveal key={s.t} delay={i * 0.1} className="h-full">
            <div className="h-full rounded-[28px] chunk p-7 sm:p-9 flex flex-col gap-10 press" style={{ background: s.bg }} data-testid={`how-step-${i + 1}`}>
              <div className="flex items-center justify-between">
                <span className="font-display font-extrabold text-6xl sm:text-7xl leading-none">0{i + 1}</span>
                <span className="w-14 h-14 rounded-full bg-white chunk-sm grid place-items-center"><s.icon className="w-6 h-6" /></span>
              </div>
              <div>
                <h3 className="font-display font-extrabold text-2xl tracking-tight">{s.t}</h3>
                <p className="mt-2 text-base leading-relaxed">{s.d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
